<ng-container *ngIf="page">
  <preview-custom-element>
    <span class="d-none">{{ {page, customer, config, translations} | json }}</span>
  </preview-custom-element>
</ng-container>
